// extracted by mini-css-extract-plugin
export default {"multiSelectContainer":"MultiSelectInput_multiSelectContainer__F7Bpq"};